/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DownloadShippingInfoReqVo,
  KoreaOutboundOrderReqVo,
  OutboundPlanListReqVo,
  ResponseExpressOutboundVo,
  ResponseKoreaExpressOutboundInfoVo,
  ResponseKoreaOutboundPicVo,
  ResponseLclFeeInfoDto,
  ResponseListKoreaOutboundOrderVo,
  ResponseListOutboundPlanBigTableVo,
  ResponseListPrintOrderVo,
  ResponseListRocketOrderOutboundSummaryInfoVo,
  ResponseListRocketOrderSummaryInfoVo,
  ResponseOrderInfoForCombineVo,
  ResponseOrderInfoForInboundPictureOrderVo,
  ResponseOrderInfoForInboundPictureVo,
  ResponseOutboundPlanForScanVo,
  ResponsePageDataOrderBigTablePageResVo,
  ResponseString,
} from '../models/index';
import {
    DownloadShippingInfoReqVoFromJSON,
    DownloadShippingInfoReqVoToJSON,
    KoreaOutboundOrderReqVoFromJSON,
    KoreaOutboundOrderReqVoToJSON,
    OutboundPlanListReqVoFromJSON,
    OutboundPlanListReqVoToJSON,
    ResponseExpressOutboundVoFromJSON,
    ResponseExpressOutboundVoToJSON,
    ResponseKoreaExpressOutboundInfoVoFromJSON,
    ResponseKoreaExpressOutboundInfoVoToJSON,
    ResponseKoreaOutboundPicVoFromJSON,
    ResponseKoreaOutboundPicVoToJSON,
    ResponseLclFeeInfoDtoFromJSON,
    ResponseLclFeeInfoDtoToJSON,
    ResponseListKoreaOutboundOrderVoFromJSON,
    ResponseListKoreaOutboundOrderVoToJSON,
    ResponseListOutboundPlanBigTableVoFromJSON,
    ResponseListOutboundPlanBigTableVoToJSON,
    ResponseListPrintOrderVoFromJSON,
    ResponseListPrintOrderVoToJSON,
    ResponseListRocketOrderOutboundSummaryInfoVoFromJSON,
    ResponseListRocketOrderOutboundSummaryInfoVoToJSON,
    ResponseListRocketOrderSummaryInfoVoFromJSON,
    ResponseListRocketOrderSummaryInfoVoToJSON,
    ResponseOrderInfoForCombineVoFromJSON,
    ResponseOrderInfoForCombineVoToJSON,
    ResponseOrderInfoForInboundPictureOrderVoFromJSON,
    ResponseOrderInfoForInboundPictureOrderVoToJSON,
    ResponseOrderInfoForInboundPictureVoFromJSON,
    ResponseOrderInfoForInboundPictureVoToJSON,
    ResponseOutboundPlanForScanVoFromJSON,
    ResponseOutboundPlanForScanVoToJSON,
    ResponsePageDataOrderBigTablePageResVoFromJSON,
    ResponsePageDataOrderBigTablePageResVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
} from '../models/index';

export interface OrderBigTableClientOrdersExportGetRequest {
    currentPage?: number;
    pageSize?: number;
    warehouseId?: number;
    mixedTransportationId?: number;
    requestGroup?: number;
    orderGroup?: number;
    orderStatus?: Array<number>;
    requestType?: number;
    internationalTransportMethodId?: number;
    ivc?: string;
    marketBarcode?: string;
    markNo?: string;
    userCode?: string;
    userAccount?: string;
    orderCode?: string;
    coupangBookingId?: string;
    coupangWarehouseBeginTime?: string;
    coupangWarehouseEndTime?: string;
    billStatus?: number;
    workerName?: string;
    ctmsType?: number;
    receiverName?: string;
    trunkWarehouseCode?: string;
    koreaWarehouseCode?: string;
    orderCreateBeginTime?: string;
    orderCreateEndTime?: string;
    goodsCode?: string;
    skuCode?: string;
    searchCode?: string;
    platformOrderCode?: string;
    trackNo?: string;
    withoutTrackNo?: number;
    orderIds?: Array<number>;
    userId?: number;
    takeGoodsMethod?: number;
    firstOrder?: number;
    expectedOutboundDate?: string;
}

export interface OrderBigTableCombineOrderInfoOrderIdGetRequest {
    orderId: number;
}

export interface OrderBigTableDownloadOrderOrderIdGetRequest {
    orderId: number;
}

export interface OrderBigTableDownloadOutboundPlanPostRequest {
    outboundPlanListReqVo?: OutboundPlanListReqVo;
}

export interface OrderBigTableDownloadShippingInfoPostRequest {
    downloadShippingInfoReqVo?: DownloadShippingInfoReqVo;
}

export interface OrderBigTableDownloadTransOrderInfoOrderIdGetRequest {
    orderId: number;
}

export interface OrderBigTableGetKoreaExpressOutboundInfoGetRequest {
    outboundType?: number;
}

export interface OrderBigTableGetLclFeeInfoOrderIdGetRequest {
    orderId: number;
}

export interface OrderBigTableGetOutboundPlanListGetRequest {
    outboundDateString?: string;
}

export interface OrderBigTableGetOutboundPlanListPostRequest {
    outboundPlanListReqVo?: OutboundPlanListReqVo;
}

export interface OrderBigTableGetPageDataGetRequest {
    currentPage?: number;
    pageSize?: number;
    warehouseId?: number;
    mixedTransportationId?: number;
    requestGroup?: number;
    orderGroup?: number;
    orderStatus?: Array<number>;
    requestType?: number;
    internationalTransportMethodId?: number;
    ivc?: string;
    marketBarcode?: string;
    markNo?: string;
    userCode?: string;
    userAccount?: string;
    orderCode?: string;
    coupangBookingId?: string;
    coupangWarehouseBeginTime?: string;
    coupangWarehouseEndTime?: string;
    billStatus?: number;
    workerName?: string;
    ctmsType?: number;
    receiverName?: string;
    trunkWarehouseCode?: string;
    koreaWarehouseCode?: string;
    orderCreateBeginTime?: string;
    orderCreateEndTime?: string;
    goodsCode?: string;
    skuCode?: string;
    searchCode?: string;
    platformOrderCode?: string;
    trackNo?: string;
    withoutTrackNo?: number;
    orderIds?: Array<number>;
    userId?: number;
    takeGoodsMethod?: number;
    firstOrder?: number;
    expectedOutboundDate?: string;
}

export interface OrderBigTableGetPrintOrderGetRequest {
    orderIds: Array<number>;
}

export interface OrderBigTableKrOrderCompletionStatisticsExportGetRequest {
    currentPage?: number;
    pageSize?: number;
    warehouseId?: number;
    mixedTransportationId?: number;
    requestGroup?: number;
    orderGroup?: number;
    orderStatus?: Array<number>;
    requestType?: number;
    internationalTransportMethodId?: number;
    ivc?: string;
    marketBarcode?: string;
    markNo?: string;
    userCode?: string;
    userAccount?: string;
    orderCode?: string;
    coupangBookingId?: string;
    coupangWarehouseBeginTime?: string;
    coupangWarehouseEndTime?: string;
    billStatus?: number;
    workerName?: string;
    ctmsType?: number;
    receiverName?: string;
    trunkWarehouseCode?: string;
    koreaWarehouseCode?: string;
    orderCreateBeginTime?: string;
    orderCreateEndTime?: string;
    goodsCode?: string;
    skuCode?: string;
    searchCode?: string;
    platformOrderCode?: string;
    trackNo?: string;
    withoutTrackNo?: number;
    orderIds?: Array<number>;
    userId?: number;
    takeGoodsMethod?: number;
    firstOrder?: number;
    expectedOutboundDate?: string;
}

export interface OrderBigTableOrderAndFeeExportGetRequest {
    outboundDateBegin: string;
    outboundDateEnd: string;
}

export interface OrderBigTableOrderAndFeeExportPostRequest {
    outboundPlanListReqVo?: OutboundPlanListReqVo;
}

export interface OrderBigTableOrderExpressOutboundGetRequest {
    orderStatus: number;
    ivc?: string;
    internationalTransportMethodId?: number;
}

export interface OrderBigTableOrderExpressOutboundMovePutRequest {
    ivc: string;
}

export interface OrderBigTableOrderInboundPictureByOrderIdOrderIdGetRequest {
    orderId: number;
}

export interface OrderBigTableOrderInboundPictureParcelTrackingNumberGetRequest {
    parcelTrackingNumber: string;
}

export interface OrderBigTableOrderKoreaExpressOutboundMovePutRequest {
    outboundTrackingNumber: string;
}

export interface OrderBigTableOrderKoreaExpressOutboundPicGetRequest {
    orderId: number;
}

export interface OrderBigTableOrderOutboundPostRequest {
    koreaOutboundOrderReqVo?: KoreaOutboundOrderReqVo;
}

export interface OrderBigTableOrderOutboundSummaryGetRequest {
    requestType?: number;
    coupangWareshouseId?: number;
    coupangInboundDate?: string;
    ivc?: string;
    coupangInboundCode?: string;
}

export interface OrderBigTableOrderPlRocketExpressOutboundGetRequest {
    orderStatus: number;
    ivc?: string;
    internationalTransportMethodId?: number;
}

export interface OrderBigTableOrderPlRocketExpressOutboundMovePutRequest {
    ivc: string;
}

export interface OrderBigTableOrderSummaryGetRequest {
    trackingNumber?: string;
    markNo?: string;
    ivc?: string;
    coupangInboundCode?: string;
}

export interface OrderBigTableOutboundPlanUserIdGetRequest {
    userId: number;
    outboundDate: string;
}

export interface OrderBigTableStockPickingListExportPostRequest {
    requestBody?: Array<number>;
}

/**
 * 
 */
export class OrderBigTableControllerApi extends runtime.BaseAPI {

    /**
     * 订单大表·客户端订单列表按搜索条件导出
     * 订单大表·客户端订单列表按搜索条件导出
     */
    async orderBigTableClientOrdersExportGetRaw(requestParameters: OrderBigTableClientOrdersExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['mixedTransportationId'] != null) {
            queryParameters['mixedTransportationId'] = requestParameters['mixedTransportationId'];
        }

        if (requestParameters['requestGroup'] != null) {
            queryParameters['requestGroup'] = requestParameters['requestGroup'];
        }

        if (requestParameters['orderGroup'] != null) {
            queryParameters['orderGroup'] = requestParameters['orderGroup'];
        }

        if (requestParameters['orderStatus'] != null) {
            queryParameters['orderStatus'] = requestParameters['orderStatus'];
        }

        if (requestParameters['requestType'] != null) {
            queryParameters['requestType'] = requestParameters['requestType'];
        }

        if (requestParameters['internationalTransportMethodId'] != null) {
            queryParameters['internationalTransportMethodId'] = requestParameters['internationalTransportMethodId'];
        }

        if (requestParameters['ivc'] != null) {
            queryParameters['ivc'] = requestParameters['ivc'];
        }

        if (requestParameters['marketBarcode'] != null) {
            queryParameters['marketBarcode'] = requestParameters['marketBarcode'];
        }

        if (requestParameters['markNo'] != null) {
            queryParameters['markNo'] = requestParameters['markNo'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['userAccount'] != null) {
            queryParameters['userAccount'] = requestParameters['userAccount'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['coupangBookingId'] != null) {
            queryParameters['coupangBookingId'] = requestParameters['coupangBookingId'];
        }

        if (requestParameters['coupangWarehouseBeginTime'] != null) {
            queryParameters['coupangWarehouseBeginTime'] = requestParameters['coupangWarehouseBeginTime'];
        }

        if (requestParameters['coupangWarehouseEndTime'] != null) {
            queryParameters['coupangWarehouseEndTime'] = requestParameters['coupangWarehouseEndTime'];
        }

        if (requestParameters['billStatus'] != null) {
            queryParameters['billStatus'] = requestParameters['billStatus'];
        }

        if (requestParameters['workerName'] != null) {
            queryParameters['workerName'] = requestParameters['workerName'];
        }

        if (requestParameters['ctmsType'] != null) {
            queryParameters['ctmsType'] = requestParameters['ctmsType'];
        }

        if (requestParameters['receiverName'] != null) {
            queryParameters['receiverName'] = requestParameters['receiverName'];
        }

        if (requestParameters['trunkWarehouseCode'] != null) {
            queryParameters['trunkWarehouseCode'] = requestParameters['trunkWarehouseCode'];
        }

        if (requestParameters['koreaWarehouseCode'] != null) {
            queryParameters['koreaWarehouseCode'] = requestParameters['koreaWarehouseCode'];
        }

        if (requestParameters['orderCreateBeginTime'] != null) {
            queryParameters['orderCreateBeginTime'] = requestParameters['orderCreateBeginTime'];
        }

        if (requestParameters['orderCreateEndTime'] != null) {
            queryParameters['orderCreateEndTime'] = requestParameters['orderCreateEndTime'];
        }

        if (requestParameters['goodsCode'] != null) {
            queryParameters['goodsCode'] = requestParameters['goodsCode'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['searchCode'] != null) {
            queryParameters['searchCode'] = requestParameters['searchCode'];
        }

        if (requestParameters['platformOrderCode'] != null) {
            queryParameters['platformOrderCode'] = requestParameters['platformOrderCode'];
        }

        if (requestParameters['trackNo'] != null) {
            queryParameters['trackNo'] = requestParameters['trackNo'];
        }

        if (requestParameters['withoutTrackNo'] != null) {
            queryParameters['withoutTrackNo'] = requestParameters['withoutTrackNo'];
        }

        if (requestParameters['orderIds'] != null) {
            queryParameters['orderIds'] = requestParameters['orderIds'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['takeGoodsMethod'] != null) {
            queryParameters['takeGoodsMethod'] = requestParameters['takeGoodsMethod'];
        }

        if (requestParameters['firstOrder'] != null) {
            queryParameters['firstOrder'] = requestParameters['firstOrder'];
        }

        if (requestParameters['expectedOutboundDate'] != null) {
            queryParameters['expectedOutboundDate'] = requestParameters['expectedOutboundDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/client-orders/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 订单大表·客户端订单列表按搜索条件导出
     * 订单大表·客户端订单列表按搜索条件导出
     */
    async orderBigTableClientOrdersExportGet(requestParameters: OrderBigTableClientOrdersExportGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.orderBigTableClientOrdersExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取订单信息 合并使用
     */
    async orderBigTableCombineOrderInfoOrderIdGetRaw(requestParameters: OrderBigTableCombineOrderInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderInfoForCombineVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderBigTableCombineOrderInfoOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/combineOrderInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderInfoForCombineVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取订单信息 合并使用
     */
    async orderBigTableCombineOrderInfoOrderIdGet(requestParameters: OrderBigTableCombineOrderInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderInfoForCombineVo> {
        const response = await this.orderBigTableCombineOrderInfoOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 下载订单
     */
    async orderBigTableDownloadOrderOrderIdGetRaw(requestParameters: OrderBigTableDownloadOrderOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderBigTableDownloadOrderOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/downloadOrder/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     * 下载订单
     */
    async orderBigTableDownloadOrderOrderIdGet(requestParameters: OrderBigTableDownloadOrderOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.orderBigTableDownloadOrderOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 下载出库计划
     */
    async orderBigTableDownloadOutboundPlanPostRaw(requestParameters: OrderBigTableDownloadOutboundPlanPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/downloadOutboundPlan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OutboundPlanListReqVoToJSON(requestParameters['outboundPlanListReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     * 下载出库计划
     */
    async orderBigTableDownloadOutboundPlanPost(requestParameters: OrderBigTableDownloadOutboundPlanPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.orderBigTableDownloadOutboundPlanPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 出库计划·海运资料下载
     * 出库计划·海运资料下载
     */
    async orderBigTableDownloadShippingInfoPostRaw(requestParameters: OrderBigTableDownloadShippingInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/downloadShippingInfo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DownloadShippingInfoReqVoToJSON(requestParameters['downloadShippingInfoReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 出库计划·海运资料下载
     * 出库计划·海运资料下载
     */
    async orderBigTableDownloadShippingInfoPost(requestParameters: OrderBigTableDownloadShippingInfoPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.orderBigTableDownloadShippingInfoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 海运阶段订单下载
     */
    async orderBigTableDownloadTransOrderInfoOrderIdGetRaw(requestParameters: OrderBigTableDownloadTransOrderInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderBigTableDownloadTransOrderInfoOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/downloadTransOrderInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     * 海运阶段订单下载
     */
    async orderBigTableDownloadTransOrderInfoOrderIdGet(requestParameters: OrderBigTableDownloadTransOrderInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.orderBigTableDownloadTransOrderInfoOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 韩国快递出库页信息
     */
    async orderBigTableGetKoreaExpressOutboundInfoGetRaw(requestParameters: OrderBigTableGetKoreaExpressOutboundInfoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseKoreaExpressOutboundInfoVo>> {
        const queryParameters: any = {};

        if (requestParameters['outboundType'] != null) {
            queryParameters['outboundType'] = requestParameters['outboundType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/getKoreaExpressOutboundInfo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseKoreaExpressOutboundInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 韩国快递出库页信息
     */
    async orderBigTableGetKoreaExpressOutboundInfoGet(requestParameters: OrderBigTableGetKoreaExpressOutboundInfoGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseKoreaExpressOutboundInfoVo> {
        const response = await this.orderBigTableGetKoreaExpressOutboundInfoGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取出库计划组的LCL预定费用信息
     */
    async orderBigTableGetLclFeeInfoOrderIdGetRaw(requestParameters: OrderBigTableGetLclFeeInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLclFeeInfoDto>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderBigTableGetLclFeeInfoOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/getLclFeeInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLclFeeInfoDtoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取出库计划组的LCL预定费用信息
     */
    async orderBigTableGetLclFeeInfoOrderIdGet(requestParameters: OrderBigTableGetLclFeeInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLclFeeInfoDto> {
        const response = await this.orderBigTableGetLclFeeInfoOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取出库计划列表
     */
    async orderBigTableGetOutboundPlanListGetRaw(requestParameters: OrderBigTableGetOutboundPlanListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOutboundPlanForScanVo>> {
        const queryParameters: any = {};

        if (requestParameters['outboundDateString'] != null) {
            queryParameters['outboundDateString'] = requestParameters['outboundDateString'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/getOutboundPlanList`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOutboundPlanForScanVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取出库计划列表
     */
    async orderBigTableGetOutboundPlanListGet(requestParameters: OrderBigTableGetOutboundPlanListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOutboundPlanForScanVo> {
        const response = await this.orderBigTableGetOutboundPlanListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端获取出库计划订单列表
     */
    async orderBigTableGetOutboundPlanListPostRaw(requestParameters: OrderBigTableGetOutboundPlanListPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListOutboundPlanBigTableVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/getOutboundPlanList`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OutboundPlanListReqVoToJSON(requestParameters['outboundPlanListReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListOutboundPlanBigTableVoFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端获取出库计划订单列表
     */
    async orderBigTableGetOutboundPlanListPost(requestParameters: OrderBigTableGetOutboundPlanListPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListOutboundPlanBigTableVo> {
        const response = await this.orderBigTableGetOutboundPlanListPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 订单大表分页查询
     */
    async orderBigTableGetPageDataGetRaw(requestParameters: OrderBigTableGetPageDataGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataOrderBigTablePageResVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['mixedTransportationId'] != null) {
            queryParameters['mixedTransportationId'] = requestParameters['mixedTransportationId'];
        }

        if (requestParameters['requestGroup'] != null) {
            queryParameters['requestGroup'] = requestParameters['requestGroup'];
        }

        if (requestParameters['orderGroup'] != null) {
            queryParameters['orderGroup'] = requestParameters['orderGroup'];
        }

        if (requestParameters['orderStatus'] != null) {
            queryParameters['orderStatus'] = requestParameters['orderStatus'];
        }

        if (requestParameters['requestType'] != null) {
            queryParameters['requestType'] = requestParameters['requestType'];
        }

        if (requestParameters['internationalTransportMethodId'] != null) {
            queryParameters['internationalTransportMethodId'] = requestParameters['internationalTransportMethodId'];
        }

        if (requestParameters['ivc'] != null) {
            queryParameters['ivc'] = requestParameters['ivc'];
        }

        if (requestParameters['marketBarcode'] != null) {
            queryParameters['marketBarcode'] = requestParameters['marketBarcode'];
        }

        if (requestParameters['markNo'] != null) {
            queryParameters['markNo'] = requestParameters['markNo'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['userAccount'] != null) {
            queryParameters['userAccount'] = requestParameters['userAccount'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['coupangBookingId'] != null) {
            queryParameters['coupangBookingId'] = requestParameters['coupangBookingId'];
        }

        if (requestParameters['coupangWarehouseBeginTime'] != null) {
            queryParameters['coupangWarehouseBeginTime'] = requestParameters['coupangWarehouseBeginTime'];
        }

        if (requestParameters['coupangWarehouseEndTime'] != null) {
            queryParameters['coupangWarehouseEndTime'] = requestParameters['coupangWarehouseEndTime'];
        }

        if (requestParameters['billStatus'] != null) {
            queryParameters['billStatus'] = requestParameters['billStatus'];
        }

        if (requestParameters['workerName'] != null) {
            queryParameters['workerName'] = requestParameters['workerName'];
        }

        if (requestParameters['ctmsType'] != null) {
            queryParameters['ctmsType'] = requestParameters['ctmsType'];
        }

        if (requestParameters['receiverName'] != null) {
            queryParameters['receiverName'] = requestParameters['receiverName'];
        }

        if (requestParameters['trunkWarehouseCode'] != null) {
            queryParameters['trunkWarehouseCode'] = requestParameters['trunkWarehouseCode'];
        }

        if (requestParameters['koreaWarehouseCode'] != null) {
            queryParameters['koreaWarehouseCode'] = requestParameters['koreaWarehouseCode'];
        }

        if (requestParameters['orderCreateBeginTime'] != null) {
            queryParameters['orderCreateBeginTime'] = requestParameters['orderCreateBeginTime'];
        }

        if (requestParameters['orderCreateEndTime'] != null) {
            queryParameters['orderCreateEndTime'] = requestParameters['orderCreateEndTime'];
        }

        if (requestParameters['goodsCode'] != null) {
            queryParameters['goodsCode'] = requestParameters['goodsCode'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['searchCode'] != null) {
            queryParameters['searchCode'] = requestParameters['searchCode'];
        }

        if (requestParameters['platformOrderCode'] != null) {
            queryParameters['platformOrderCode'] = requestParameters['platformOrderCode'];
        }

        if (requestParameters['trackNo'] != null) {
            queryParameters['trackNo'] = requestParameters['trackNo'];
        }

        if (requestParameters['withoutTrackNo'] != null) {
            queryParameters['withoutTrackNo'] = requestParameters['withoutTrackNo'];
        }

        if (requestParameters['orderIds'] != null) {
            queryParameters['orderIds'] = requestParameters['orderIds'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['takeGoodsMethod'] != null) {
            queryParameters['takeGoodsMethod'] = requestParameters['takeGoodsMethod'];
        }

        if (requestParameters['firstOrder'] != null) {
            queryParameters['firstOrder'] = requestParameters['firstOrder'];
        }

        if (requestParameters['expectedOutboundDate'] != null) {
            queryParameters['expectedOutboundDate'] = requestParameters['expectedOutboundDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/getPageData`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataOrderBigTablePageResVoFromJSON(jsonValue));
    }

    /**
     * 
     * 订单大表分页查询
     */
    async orderBigTableGetPageDataGet(requestParameters: OrderBigTableGetPageDataGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataOrderBigTablePageResVo> {
        const response = await this.orderBigTableGetPageDataGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取打印订单信息
     */
    async orderBigTableGetPrintOrderGetRaw(requestParameters: OrderBigTableGetPrintOrderGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListPrintOrderVo>> {
        if (requestParameters['orderIds'] == null) {
            throw new runtime.RequiredError(
                'orderIds',
                'Required parameter "orderIds" was null or undefined when calling orderBigTableGetPrintOrderGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderIds'] != null) {
            queryParameters['orderIds'] = requestParameters['orderIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/getPrintOrder`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListPrintOrderVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取打印订单信息
     */
    async orderBigTableGetPrintOrderGet(requestParameters: OrderBigTableGetPrintOrderGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListPrintOrderVo> {
        const response = await this.orderBigTableGetPrintOrderGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 订单大表·韩国仓库订单完成统计导出
     * 订单大表·韩国仓库订单完成统计导出
     */
    async orderBigTableKrOrderCompletionStatisticsExportGetRaw(requestParameters: OrderBigTableKrOrderCompletionStatisticsExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['mixedTransportationId'] != null) {
            queryParameters['mixedTransportationId'] = requestParameters['mixedTransportationId'];
        }

        if (requestParameters['requestGroup'] != null) {
            queryParameters['requestGroup'] = requestParameters['requestGroup'];
        }

        if (requestParameters['orderGroup'] != null) {
            queryParameters['orderGroup'] = requestParameters['orderGroup'];
        }

        if (requestParameters['orderStatus'] != null) {
            queryParameters['orderStatus'] = requestParameters['orderStatus'];
        }

        if (requestParameters['requestType'] != null) {
            queryParameters['requestType'] = requestParameters['requestType'];
        }

        if (requestParameters['internationalTransportMethodId'] != null) {
            queryParameters['internationalTransportMethodId'] = requestParameters['internationalTransportMethodId'];
        }

        if (requestParameters['ivc'] != null) {
            queryParameters['ivc'] = requestParameters['ivc'];
        }

        if (requestParameters['marketBarcode'] != null) {
            queryParameters['marketBarcode'] = requestParameters['marketBarcode'];
        }

        if (requestParameters['markNo'] != null) {
            queryParameters['markNo'] = requestParameters['markNo'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['userAccount'] != null) {
            queryParameters['userAccount'] = requestParameters['userAccount'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['coupangBookingId'] != null) {
            queryParameters['coupangBookingId'] = requestParameters['coupangBookingId'];
        }

        if (requestParameters['coupangWarehouseBeginTime'] != null) {
            queryParameters['coupangWarehouseBeginTime'] = requestParameters['coupangWarehouseBeginTime'];
        }

        if (requestParameters['coupangWarehouseEndTime'] != null) {
            queryParameters['coupangWarehouseEndTime'] = requestParameters['coupangWarehouseEndTime'];
        }

        if (requestParameters['billStatus'] != null) {
            queryParameters['billStatus'] = requestParameters['billStatus'];
        }

        if (requestParameters['workerName'] != null) {
            queryParameters['workerName'] = requestParameters['workerName'];
        }

        if (requestParameters['ctmsType'] != null) {
            queryParameters['ctmsType'] = requestParameters['ctmsType'];
        }

        if (requestParameters['receiverName'] != null) {
            queryParameters['receiverName'] = requestParameters['receiverName'];
        }

        if (requestParameters['trunkWarehouseCode'] != null) {
            queryParameters['trunkWarehouseCode'] = requestParameters['trunkWarehouseCode'];
        }

        if (requestParameters['koreaWarehouseCode'] != null) {
            queryParameters['koreaWarehouseCode'] = requestParameters['koreaWarehouseCode'];
        }

        if (requestParameters['orderCreateBeginTime'] != null) {
            queryParameters['orderCreateBeginTime'] = requestParameters['orderCreateBeginTime'];
        }

        if (requestParameters['orderCreateEndTime'] != null) {
            queryParameters['orderCreateEndTime'] = requestParameters['orderCreateEndTime'];
        }

        if (requestParameters['goodsCode'] != null) {
            queryParameters['goodsCode'] = requestParameters['goodsCode'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['searchCode'] != null) {
            queryParameters['searchCode'] = requestParameters['searchCode'];
        }

        if (requestParameters['platformOrderCode'] != null) {
            queryParameters['platformOrderCode'] = requestParameters['platformOrderCode'];
        }

        if (requestParameters['trackNo'] != null) {
            queryParameters['trackNo'] = requestParameters['trackNo'];
        }

        if (requestParameters['withoutTrackNo'] != null) {
            queryParameters['withoutTrackNo'] = requestParameters['withoutTrackNo'];
        }

        if (requestParameters['orderIds'] != null) {
            queryParameters['orderIds'] = requestParameters['orderIds'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['takeGoodsMethod'] != null) {
            queryParameters['takeGoodsMethod'] = requestParameters['takeGoodsMethod'];
        }

        if (requestParameters['firstOrder'] != null) {
            queryParameters['firstOrder'] = requestParameters['firstOrder'];
        }

        if (requestParameters['expectedOutboundDate'] != null) {
            queryParameters['expectedOutboundDate'] = requestParameters['expectedOutboundDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/kr-order-completion-statistics/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 订单大表·韩国仓库订单完成统计导出
     * 订单大表·韩国仓库订单完成统计导出
     */
    async orderBigTableKrOrderCompletionStatisticsExportGet(requestParameters: OrderBigTableKrOrderCompletionStatisticsExportGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.orderBigTableKrOrderCompletionStatisticsExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 订单及费用下载
     */
    async orderBigTableOrderAndFeeExportGetRaw(requestParameters: OrderBigTableOrderAndFeeExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['outboundDateBegin'] == null) {
            throw new runtime.RequiredError(
                'outboundDateBegin',
                'Required parameter "outboundDateBegin" was null or undefined when calling orderBigTableOrderAndFeeExportGet().'
            );
        }

        if (requestParameters['outboundDateEnd'] == null) {
            throw new runtime.RequiredError(
                'outboundDateEnd',
                'Required parameter "outboundDateEnd" was null or undefined when calling orderBigTableOrderAndFeeExportGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['outboundDateBegin'] != null) {
            queryParameters['outboundDateBegin'] = requestParameters['outboundDateBegin'];
        }

        if (requestParameters['outboundDateEnd'] != null) {
            queryParameters['outboundDateEnd'] = requestParameters['outboundDateEnd'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/orderAndFee/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     * 订单及费用下载
     */
    async orderBigTableOrderAndFeeExportGet(requestParameters: OrderBigTableOrderAndFeeExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.orderBigTableOrderAndFeeExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 订单及费用下载
     */
    async orderBigTableOrderAndFeeExportPostRaw(requestParameters: OrderBigTableOrderAndFeeExportPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/orderAndFee/export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OutboundPlanListReqVoToJSON(requestParameters['outboundPlanListReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     * 订单及费用下载
     */
    async orderBigTableOrderAndFeeExportPost(requestParameters: OrderBigTableOrderAndFeeExportPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.orderBigTableOrderAndFeeExportPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取中国出库订单列表
     */
    async orderBigTableOrderExpressOutboundGetRaw(requestParameters: OrderBigTableOrderExpressOutboundGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseExpressOutboundVo>> {
        if (requestParameters['orderStatus'] == null) {
            throw new runtime.RequiredError(
                'orderStatus',
                'Required parameter "orderStatus" was null or undefined when calling orderBigTableOrderExpressOutboundGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ivc'] != null) {
            queryParameters['ivc'] = requestParameters['ivc'];
        }

        if (requestParameters['orderStatus'] != null) {
            queryParameters['orderStatus'] = requestParameters['orderStatus'];
        }

        if (requestParameters['internationalTransportMethodId'] != null) {
            queryParameters['internationalTransportMethodId'] = requestParameters['internationalTransportMethodId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/order/expressOutbound`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseExpressOutboundVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取中国出库订单列表
     */
    async orderBigTableOrderExpressOutboundGet(requestParameters: OrderBigTableOrderExpressOutboundGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseExpressOutboundVo> {
        const response = await this.orderBigTableOrderExpressOutboundGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 订单大表·电商快递出库移动
     * 订单大表·电商快递出库移动
     */
    async orderBigTableOrderExpressOutboundMovePutRaw(requestParameters: OrderBigTableOrderExpressOutboundMovePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['ivc'] == null) {
            throw new runtime.RequiredError(
                'ivc',
                'Required parameter "ivc" was null or undefined when calling orderBigTableOrderExpressOutboundMovePut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ivc'] != null) {
            queryParameters['ivc'] = requestParameters['ivc'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/order/expressOutboundMove`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 订单大表·电商快递出库移动
     * 订单大表·电商快递出库移动
     */
    async orderBigTableOrderExpressOutboundMovePut(requestParameters: OrderBigTableOrderExpressOutboundMovePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderBigTableOrderExpressOutboundMovePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取入库上传照片时的订单信息  订单维度
     */
    async orderBigTableOrderInboundPictureByOrderIdOrderIdGetRaw(requestParameters: OrderBigTableOrderInboundPictureByOrderIdOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderInfoForInboundPictureOrderVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderBigTableOrderInboundPictureByOrderIdOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/order/inboundPictureByOrderId/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderInfoForInboundPictureOrderVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取入库上传照片时的订单信息  订单维度
     */
    async orderBigTableOrderInboundPictureByOrderIdOrderIdGet(requestParameters: OrderBigTableOrderInboundPictureByOrderIdOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderInfoForInboundPictureOrderVo> {
        const response = await this.orderBigTableOrderInboundPictureByOrderIdOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取入库上传照片时的订单信息
     */
    async orderBigTableOrderInboundPictureParcelTrackingNumberGetRaw(requestParameters: OrderBigTableOrderInboundPictureParcelTrackingNumberGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderInfoForInboundPictureVo>> {
        if (requestParameters['parcelTrackingNumber'] == null) {
            throw new runtime.RequiredError(
                'parcelTrackingNumber',
                'Required parameter "parcelTrackingNumber" was null or undefined when calling orderBigTableOrderInboundPictureParcelTrackingNumberGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/order/inboundPicture/{parcelTrackingNumber}`.replace(`{${"parcelTrackingNumber"}}`, encodeURIComponent(String(requestParameters['parcelTrackingNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderInfoForInboundPictureVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取入库上传照片时的订单信息
     */
    async orderBigTableOrderInboundPictureParcelTrackingNumberGet(requestParameters: OrderBigTableOrderInboundPictureParcelTrackingNumberGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderInfoForInboundPictureVo> {
        const response = await this.orderBigTableOrderInboundPictureParcelTrackingNumberGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 韩国快递出库订单移动
     */
    async orderBigTableOrderKoreaExpressOutboundMovePutRaw(requestParameters: OrderBigTableOrderKoreaExpressOutboundMovePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['outboundTrackingNumber'] == null) {
            throw new runtime.RequiredError(
                'outboundTrackingNumber',
                'Required parameter "outboundTrackingNumber" was null or undefined when calling orderBigTableOrderKoreaExpressOutboundMovePut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['outboundTrackingNumber'] != null) {
            queryParameters['outboundTrackingNumber'] = requestParameters['outboundTrackingNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/order/koreaExpressOutboundMove`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 韩国快递出库订单移动
     */
    async orderBigTableOrderKoreaExpressOutboundMovePut(requestParameters: OrderBigTableOrderKoreaExpressOutboundMovePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderBigTableOrderKoreaExpressOutboundMovePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取韩国出库图片信息
     */
    async orderBigTableOrderKoreaExpressOutboundPicGetRaw(requestParameters: OrderBigTableOrderKoreaExpressOutboundPicGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseKoreaOutboundPicVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderBigTableOrderKoreaExpressOutboundPicGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/order/koreaExpressOutboundPic`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseKoreaOutboundPicVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取韩国出库图片信息
     */
    async orderBigTableOrderKoreaExpressOutboundPicGet(requestParameters: OrderBigTableOrderKoreaExpressOutboundPicGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseKoreaOutboundPicVo> {
        const response = await this.orderBigTableOrderKoreaExpressOutboundPicGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取韩国出库订单列表
     */
    async orderBigTableOrderOutboundPostRaw(requestParameters: OrderBigTableOrderOutboundPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListKoreaOutboundOrderVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/order/outbound`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KoreaOutboundOrderReqVoToJSON(requestParameters['koreaOutboundOrderReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListKoreaOutboundOrderVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取韩国出库订单列表
     */
    async orderBigTableOrderOutboundPost(requestParameters: OrderBigTableOrderOutboundPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListKoreaOutboundOrderVo> {
        const response = await this.orderBigTableOrderOutboundPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取韩国火箭订单出库订单摘要信息
     */
    async orderBigTableOrderOutboundSummaryGetRaw(requestParameters: OrderBigTableOrderOutboundSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListRocketOrderOutboundSummaryInfoVo>> {
        const queryParameters: any = {};

        if (requestParameters['requestType'] != null) {
            queryParameters['requestType'] = requestParameters['requestType'];
        }

        if (requestParameters['coupangWareshouseId'] != null) {
            queryParameters['coupangWareshouseId'] = requestParameters['coupangWareshouseId'];
        }

        if (requestParameters['coupangInboundDate'] != null) {
            queryParameters['coupangInboundDate'] = requestParameters['coupangInboundDate'];
        }

        if (requestParameters['ivc'] != null) {
            queryParameters['ivc'] = requestParameters['ivc'];
        }

        if (requestParameters['coupangInboundCode'] != null) {
            queryParameters['coupangInboundCode'] = requestParameters['coupangInboundCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/order/outboundSummary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListRocketOrderOutboundSummaryInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取韩国火箭订单出库订单摘要信息
     */
    async orderBigTableOrderOutboundSummaryGet(requestParameters: OrderBigTableOrderOutboundSummaryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListRocketOrderOutboundSummaryInfoVo> {
        const response = await this.orderBigTableOrderOutboundSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 3PL/火箭快递出库列表，扫描规则与电商快递出库相同。 订单大表·3PL/火箭快递出库查询
     * 订单大表·3PL/火箭快递出库查询
     */
    async orderBigTableOrderPlRocketExpressOutboundGetRaw(requestParameters: OrderBigTableOrderPlRocketExpressOutboundGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseExpressOutboundVo>> {
        if (requestParameters['orderStatus'] == null) {
            throw new runtime.RequiredError(
                'orderStatus',
                'Required parameter "orderStatus" was null or undefined when calling orderBigTableOrderPlRocketExpressOutboundGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ivc'] != null) {
            queryParameters['ivc'] = requestParameters['ivc'];
        }

        if (requestParameters['orderStatus'] != null) {
            queryParameters['orderStatus'] = requestParameters['orderStatus'];
        }

        if (requestParameters['internationalTransportMethodId'] != null) {
            queryParameters['internationalTransportMethodId'] = requestParameters['internationalTransportMethodId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/order/plRocketExpressOutbound`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseExpressOutboundVoFromJSON(jsonValue));
    }

    /**
     * 3PL/火箭快递出库列表，扫描规则与电商快递出库相同。 订单大表·3PL/火箭快递出库查询
     * 订单大表·3PL/火箭快递出库查询
     */
    async orderBigTableOrderPlRocketExpressOutboundGet(requestParameters: OrderBigTableOrderPlRocketExpressOutboundGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseExpressOutboundVo> {
        const response = await this.orderBigTableOrderPlRocketExpressOutboundGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 3PL/火箭快递出库扫描移动：结算完成→出库待定，出库待定→出库完成。 订单大表·3PL/火箭快递出库移动
     * 订单大表·3PL/火箭快递出库移动
     */
    async orderBigTableOrderPlRocketExpressOutboundMovePutRaw(requestParameters: OrderBigTableOrderPlRocketExpressOutboundMovePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['ivc'] == null) {
            throw new runtime.RequiredError(
                'ivc',
                'Required parameter "ivc" was null or undefined when calling orderBigTableOrderPlRocketExpressOutboundMovePut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ivc'] != null) {
            queryParameters['ivc'] = requestParameters['ivc'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/order/plRocketExpressOutboundMove`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 3PL/火箭快递出库扫描移动：结算完成→出库待定，出库待定→出库完成。 订单大表·3PL/火箭快递出库移动
     * 订单大表·3PL/火箭快递出库移动
     */
    async orderBigTableOrderPlRocketExpressOutboundMovePut(requestParameters: OrderBigTableOrderPlRocketExpressOutboundMovePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderBigTableOrderPlRocketExpressOutboundMovePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取火箭订单摘要信息
     */
    async orderBigTableOrderSummaryGetRaw(requestParameters: OrderBigTableOrderSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListRocketOrderSummaryInfoVo>> {
        const queryParameters: any = {};

        if (requestParameters['trackingNumber'] != null) {
            queryParameters['trackingNumber'] = requestParameters['trackingNumber'];
        }

        if (requestParameters['markNo'] != null) {
            queryParameters['markNo'] = requestParameters['markNo'];
        }

        if (requestParameters['ivc'] != null) {
            queryParameters['ivc'] = requestParameters['ivc'];
        }

        if (requestParameters['coupangInboundCode'] != null) {
            queryParameters['coupangInboundCode'] = requestParameters['coupangInboundCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/order/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListRocketOrderSummaryInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取火箭订单摘要信息
     */
    async orderBigTableOrderSummaryGet(requestParameters: OrderBigTableOrderSummaryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListRocketOrderSummaryInfoVo> {
        const response = await this.orderBigTableOrderSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取用户出库计划订单列表
     */
    async orderBigTableOutboundPlanUserIdGetRaw(requestParameters: OrderBigTableOutboundPlanUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListOutboundPlanBigTableVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling orderBigTableOutboundPlanUserIdGet().'
            );
        }

        if (requestParameters['outboundDate'] == null) {
            throw new runtime.RequiredError(
                'outboundDate',
                'Required parameter "outboundDate" was null or undefined when calling orderBigTableOutboundPlanUserIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['outboundDate'] != null) {
            queryParameters['outboundDate'] = requestParameters['outboundDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/outboundPlan/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListOutboundPlanBigTableVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取用户出库计划订单列表
     */
    async orderBigTableOutboundPlanUserIdGet(requestParameters: OrderBigTableOutboundPlanUserIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListOutboundPlanBigTableVo> {
        const response = await this.orderBigTableOutboundPlanUserIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 库存拣货清单下载Excel导出
     */
    async orderBigTableStockPickingListExportPostRaw(requestParameters: OrderBigTableStockPickingListExportPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderBigTable/stockPickingList/export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     * 库存拣货清单下载Excel导出
     */
    async orderBigTableStockPickingListExportPost(requestParameters: OrderBigTableStockPickingListExportPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.orderBigTableStockPickingListExportPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
